import { render } from "./addTargetDialog.vue?vue&type=template&id=2f9d56ff"
import script from "./addTargetDialog.vue?vue&type=script&lang=js"
export * from "./addTargetDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__